import React, { useState, useEffect } from 'react';
import { DatePicker, Button, Space, Tooltip } from 'antd';
import dayjs from '../../utils/dayjs';

const DatetimeInput = ({ fieldName, value, handleInputChange, dateOnly = false }) => {
  const [displayValue, setDisplayValue] = useState(null);

  // Update displayValue when value changes
  useEffect(() => {
    if (value) {
      const parsedValue = dayjs(value);
      if (parsedValue.isValid() && parsedValue.year() >= 1902) {
        setDisplayValue(parsedValue);
      } else {
        setDisplayValue(null);
      }
    } else {
      setDisplayValue(null);
    }
  }, [value]);

  useEffect(() => {
    if (value && dayjs(value).isSame(dayjs('0001-01-01T00:00:00'))) {
      const now = dayjs();
      setDisplayValue(now);
      handleInputChange(fieldName, now.toISOString());
    }
  }, [value, fieldName, handleInputChange]);

  const handleNowClick = () => {
    const now = dayjs();
    setDisplayValue(now);
    handleInputChange(fieldName, now.toISOString());
  };

  const handleDateChange = (date, dateString) => {
    if (date && date.isValid() && date.year() >= 1902) {
      setDisplayValue(date);
      handleInputChange(fieldName, dateOnly ? date.format('YYYY-MM-DD') : date.toISOString());
    } else {
      setDisplayValue(null);
      handleInputChange(fieldName, null);
    }
  };

  if (dateOnly) {
    return (
      <DatePicker
        value={displayValue}
        placeholder="Select date"
        allowClear={true}
        format="YYYY-MM-DD"
        onChange={handleDateChange}
      />
    );
  }

  return (
    <Space>
      <DatePicker
        value={displayValue}
        placeholder="Select date and time"
        allowClear={true}
        showTime={{ format: 'HH:mm' }}
        format="YYYY-MM-DD HH:mm"
        onChange={handleDateChange}
      />
      {!displayValue && (
        <Tooltip title="Set to current date and time">
          <Button type="primary" size="small" onClick={handleNowClick}>
            Now
          </Button>
        </Tooltip>
      )}
    </Space>
  );
};

export default DatetimeInput;